/** Einheitliche Anruf-Ergebnisse (Desktop FloatingCall + Fahrmodus) */
export const CALL_OUTCOMES = [
  { id: 'reached_appt',     label: 'Erreicht – Termin gesetzt',     emoji: '✅', color: '#16a34a' },
  { id: 'reached_followup', label: 'Erreicht – Follow-up nötig',    emoji: '🔵', color: '#0f8a53' },
  { id: 'decision_maker',   label: 'Entscheider erreicht',          emoji: '👤', color: '#0d9488' },
  { id: 'reached_no',       label: 'Erreicht – Kein Interesse',     emoji: '🔴', color: '#dc2626' },
  { id: 'not_voicemail',    label: 'Nicht erreicht – Voicemail',    emoji: '📭', color: '#d97706' },
  { id: 'not_busy',         label: 'Nicht erreicht – Besetzt',      emoji: '🔄', color: '#7a5fb8' },
  { id: 'not_noanswer',     label: 'Nicht erreicht – Kein Anschluss', emoji: '📵', color: '#6c7a70' },
  { id: 'gatekeeper',       label: 'Gatekeeper',                    emoji: '🚧', color: '#92400e' },
  { id: 'callback',         label: 'Rückruf vereinbart',            emoji: '📞', color: '#0891b2' },
];

export const CAR_OUTCOMES = CALL_OUTCOMES.filter(o =>
  ['reached_appt', 'reached_followup', 'reached_no', 'callback', 'gatekeeper', 'not_voicemail', 'not_noanswer'].includes(o.id)
);
